/**
 * @fileoverview Provides a utility function to remove common leading whitespace from multiline text. This is similar to Python's textwrap.dedent.
 */

/**
 * Remove common leading whitespace from every line in text.
 * Similar to Python's textwrap.dedent.
 */
export function dedent(text: string): string {
  const lines = text.split('\n')

  if (lines.length === 0) {
    return text
  }

  const minIndent = minIndentationAmount(lines)

  if (minIndent === 0) {
    return text
  }

  return lines
    .map((line) => {
      if (line.trim().length === 0) {
        return line
      }
      return line.slice(minIndent)
    })
    .join('\n')
}

/**
 * Find the minimum indentation amount for a list of lines.
 */
export function minIndentationAmount(lines: string[]): number {
  const nonEmptyLines = lines.filter((line) => line.trim().length > 0)
  if (nonEmptyLines.length === 0) {
    return 0
  }
  return Math.min(...lines.map((line) => line.match(/^[ \t]*/)?.[0].length || 0))
}
